/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-refresh/only-export-components */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { FC, createContext, useContext, useEffect, useState } from 'react'
import { WithChildren } from '../../helpers'
import { envConfig } from '../../../utils/config'

export interface PageLink {
  title: string
  path: string
  isActive: boolean
  isSeparator?: boolean
  state?: {
    from: string
  }
  icon?: React.ReactNode
}

export interface SubDescription {
  title: string,
  description: string,
  items: string[]
}

export interface PageDataContextModel {
  pageTitle?: string
  setPageTitle: (_title: string) => void
  pageDescription?: React.ReactNode
  setPageDescription: (_description: React.ReactNode) => void
  pageBreadcrumbs?: Array<PageLink>
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => void,
  siteTitle?: string;
  setSiteTitle: (title: string) => void;
  purpose?: string;
  setPurpose: (_purpose: string) => void;
  completionGuide?: string;
  setCompletionGuide: (_completionGuide: string) => void
  subTitle?: string;
  setSubTitle: (_subTitle: string) => void;
  subText?: string;
  setSubText: (_subText: string) => void;
  subDescription?: SubDescription;
  setSubDescription: (_subDescription: SubDescription) => void;
}

const PageDataContext = createContext<PageDataContextModel>({
  setPageTitle: (_title: string) => { },
  setPageBreadcrumbs: (_breadcrumbs: Array<PageLink>) => { },
  setPageDescription: (_description: React.ReactNode) => { },
  setSiteTitle: (_sitetitle: string) => { },
  setPurpose: (_purpose: string) => { },
  setCompletionGuide: (_completionGuide: string) => { },
  setSubTitle: (_subTitle: string) => { },
  setSubText: (_subText: string) => { },
  setSubDescription: (_subDescription: SubDescription) => { }
})

const PageDataProvider: FC<WithChildren> = ({ children }) => {
  const [pageTitle, setPageTitle] = useState<string>('')
  const [pageDescription, setPageDescription] = useState<React.ReactNode>('')
  const [pageBreadcrumbs, setPageBreadcrumbs] = useState<Array<PageLink>>([])
  const [siteTitle, setSiteTitle] = useState<string>('')
  const [purpose, setPurpose] = useState<string>('');
  const [completionGuide, setCompletionGuide] = useState<string>('');
  const [subTitle, setSubTitle] = useState<string>('');
  const [subText, setSubText] = useState<string>('');
  const [subDescription, setSubDescription] = useState<SubDescription | undefined>(undefined);
  const value: PageDataContextModel = {
    pageTitle,
    setPageTitle,
    pageDescription,
    setPageDescription,
    pageBreadcrumbs,
    setPageBreadcrumbs,
    siteTitle,
    setSiteTitle,
    setPurpose,
    purpose,
    setCompletionGuide,
    completionGuide,
    subTitle,
    setSubTitle,
    subText,
    setSubText,
    subDescription,
    setSubDescription
  }
  return <PageDataContext.Provider value={value}>{children}</PageDataContext.Provider>
}

function usePageData() {
  return useContext(PageDataContext)
}

type Props = {
  description?: React.ReactNode
  breadcrumbs?: Array<PageLink>
  sitetitle?: string
  purpose?: string
  completionGuide?: string
  subTitle?: string
  subText?: string,
  subDescription?: {
    title: string,
    description: string,
    items: string[]
  }
}

const PageTitle: FC<Props & WithChildren> = ({ children, description, breadcrumbs, sitetitle, purpose, completionGuide, subTitle, subText, subDescription }) => {
  const { setPageTitle, setPageDescription, setPageBreadcrumbs, setSiteTitle, setPurpose, setCompletionGuide, setSubTitle, setSubText, setSubDescription } = usePageData()
  useEffect(() => {
    if (children) {
      setPageTitle(children.toString())
    }
    return () => {
      setPageTitle('')
    }
  }, [children])

  useEffect(() => {
    if (description) {
      setPageDescription(description)
    }
    return () => {
      setPageDescription('')
    }
  }, [description])

  useEffect(() => {
    if (breadcrumbs) {
      setPageBreadcrumbs(breadcrumbs)
    }
    return () => {
      setPageBreadcrumbs([])
    }
  }, [breadcrumbs])

  useEffect(() => {
    if (sitetitle) {
      setSiteTitle(sitetitle)
    }
    return () => {
      setSiteTitle(envConfig.APP_TITLE)
    }
  }, [sitetitle])

  useEffect(() => {
    if (purpose) {
      setPurpose(purpose)
    }
    return () => {
      setPurpose('')
    }
  }, [purpose])

  useEffect(() => {
    if (completionGuide) {
      setCompletionGuide(completionGuide)
    }
    return () => {
      setCompletionGuide('')
    }
  }, [completionGuide])

  useEffect(() => {
    if (subTitle) {
      setSubTitle(subTitle)
    }
    return () => {
      setSubTitle('')
    }
  }, [subTitle])

  useEffect(() => {
    if (subText) {
      setSubText(subText)
    }
    return () => {
      setSubText('')
    }
  }, [subText])

  useEffect(() => {
    if (subDescription) {
      setSubDescription(subDescription)
    }
    return () => {
      setSubDescription({ title: '', description: '', items: [] })
    }
  }, [subDescription])
  return <></>
}

const PageDescription: FC<WithChildren> = ({ children }) => {
  const { setPageDescription } = usePageData()
  useEffect(() => {
    if (children) {
      setPageDescription(children.toString())
    }
    return () => {
      setPageDescription('')
    }
  }, [children])
  return <></>
}

const SiteTitle: FC<WithChildren> = ({ children }) => {
  const { setSiteTitle } = usePageData()
  useEffect(() => {
    if (children) {
      setSiteTitle(children.toString())
    }
    return () => {
      setSiteTitle(envConfig.APP_TITLE)
    }
  }, [children])
  return <></>
}

const purpose: FC<WithChildren> = ({ children }) => {
  const { setPurpose } = usePageData()
  useEffect(() => {
    if (children) {
      setPurpose(children.toString())
    }
    return () => {
      setPurpose('')
    }
  }, [children])
  return <></>
}

const completionGuide: FC<WithChildren> = ({ children }) => {
  const { setCompletionGuide } = usePageData()
  useEffect(() => {
    if (children) {
      setCompletionGuide(children.toString())
    }
    return () => {
      setCompletionGuide('')
    }
  }, [children])
  return <></>
}

export { PageDescription, PageTitle, SiteTitle, purpose, PageDataProvider, completionGuide, usePageData }
